export default {
  // Hero section
  'hero.title': 'ابزارهای تایمر حرفه‌ای آنلاین',
  'hero.subtitle': 'ابزار زمان‌سنجی مناسب را برای نیازهای خود انتخاب کنید',

  // Tool cards
  'timer.title': 'تایمر',
  'timer.description': 'تایمر شمارش معکوس برای کار، مطالعه و زندگی',
  'timer.longDescription': 'تایمر شمارش معکوس برای بهره‌وری، آشپزی و مدیریت زمان',
  'timer.button': 'شروع تایمر',

  'stopwatch.title': 'کرنومتر',
  'stopwatch.description': 'ابزار زمان‌سنجی با دقت بالا',
  'stopwatch.longDescription': 'کرنومتر با دقت بالا برای ورزش، تمرین و زمان‌سنجی دقیق',
  'stopwatch.button': 'شروع کرنومتر',

  'worldclock.title': 'ساعت جهانی',
  'worldclock.description': 'مناطق زمانی سراسر جهان را مشاهده کنید',
  'worldclock.longDescription': 'نمایش لحظه‌ای زمان شهرهای بزرگ جهان با محاسبات هوشمند منطقه زمانی',
  'worldclock.button': 'مشاهده ساعت جهانی',

  // Features section
  'features.title': 'چرا timer.today را انتخاب کنید؟',
  'features.reliable.title': 'قابل اعتماد و دقیق',
  'features.reliable.desc': 'زمان‌سنجی با دقت میلی‌ثانیه با قابلیت اعتماد مبتنی بر مرورگر',
  'features.crossPlatform.title': 'چند پلتفرمی',
  'features.crossPlatform.desc': 'به‌طور یکپارچه در دستگاه‌های دسکتاپ، تبلت و موبایل کار می‌کند',
  'features.smartNotifications.title': 'اعلان‌های هوشمند',
  'features.smartNotifications.desc': 'هشدارهای صوتی و اعلان‌های دسکتاپ هنگام اتمام زمان',
  'features.easyToUse.title': 'آسان برای استفاده',
  'features.easyToUse.desc': 'رابط کاربری ساده با کنترل‌های شهودی برای همه کاربران',

  // Keywords section
  'keywords.timer': 'timer countdown pomodoro focus work break',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
